module.exports = __webpack_public_path__ + "static/family-0532e3c7e2c947f99f4553eda3430a41.jpg";